import request from '@/utils/request'
import moment from 'moment'
export function reportAvailability(protocolId) {
  const method = 'get'
  const url = `/report_availability/${protocolId}`
  return request({
    url,
    method
  })
}

function download (path, filename) {
  return request({
    url: path,
    method: 'GET',
    responseType: 'blob',
  }).then(response => {
    const fileURL = window.URL.createObjectURL(new Blob([response]))
    const fileLink = document.createElement('a')
    fileLink.href = fileURL
    fileLink.setAttribute('download', filename)
    document.body.appendChild(fileLink)
    fileLink.click()
    fileLink.remove()
  })
}

export function reportPharma (protocol) {
  const date = moment().format('DD-MM-YYYY')
  const filename = `Report_ECDS_Pharmacies_${protocol.name}_${date}.xlsx`
  return download(`/report/pharma/${protocol.id}`, filename)
}

export function reportStock (protocol) {
  const date = moment().format('DD-MM-YYYY')
  const filename = `Report_ECDS_Stock_${protocol.name}_${date}.xlsx`
  return download(`/report/report_stock/${protocol.id}`, filename)
}

export function reportUsers () {
  const date = moment().format('DD-MM-YYYY')
  const filename = `Report_eCDS_Users_${date}.xlsx`
  return download(`report/users`, filename)
}

export function reportProtocolSiteUsers () {
  const date = moment().format('DD-MM-YYYY')
  const filename = `Report_eCDS_Users_Protocol_Site_${date}.xlsx`
  return download(`report/users_protocol`, filename)
}

export function reportMonitor (protocol, site) {
  const date = moment().format('DD-MM-YYYY')
  if (site && site.id) {
    const filename = `Report_eCDS_Monitor_${protocol.name}_${site.city}_${site.code}_${date}.xlsx`
    return download(`report/monitor/${protocol.id}/${site.id}`, filename)
  } else {
    const filename = `Report_eCDS_Monitor_${protocol.name}_${date}.xlsx`
    return download(`report/monitor/${protocol.id}/`, filename)
  }
}

export function reportSite(protocol) {
  const date = moment().format('DD-MM-YYYY')
  const filename = `Report_eCDS_${protocol.name}_${date}.xlsx`
  return download(`report/site/${protocol.id}`, filename)
}
